import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView, initAnalytics } from '@/lib/analytics';

let initialized = false;

export const useAnalytics = () => {
  const location = useLocation();
  
  // Initialize analytics once
  useEffect(() => {
    if (!initialized) {
      initAnalytics();
      initialized = true;
    }
  }, []);
  
  // Track page views on route change
  useEffect(() => {
    trackPageView(location.pathname);
  }, [location.pathname]);
};

export { trackEvent } from '@/lib/analytics';
